import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import SideBar from "./SideBar";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Button } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import Swal from "sweetalert2";
import HeaderName from "./HeaderName";

import { Link } from "react-router-dom";
import {
  FaClipboardList,
  FaCalculator,
  FaFileExport,
  FaAngleDoubleRight,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import { api } from "../../api/api";
function Stock(props) {
  // const token = localStorage.getItem("token");
  // const url = "http://skinsymphonybackend.kwintechnologykw21.com:5000/api/";
  // const api = axios.create({
  //   baseURL: url,
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //     "Content-Type": "application/json",
  //   },
  // });

  const scroll = {
    height: "600px",
    overflowX: "scroll",
  };

  const [searchProResults, setSearchProResults] = useState([]);
  const [showProSearch, setShowProSearch] = useState(false);
  const [hidePro, setHidePro] = useState(true);
  const [proName, setProName] = useState("");

  const [searchMedResults, setSearchMedResults] = useState([]);
  const [showMedSearch, setShowMedSearch] = useState(false);
  const [hideMed, setHideMed] = useState(true);
  const [medName, setMedName] = useState("");

  const [searchProAccResults, setSearchProAccResults] = useState([]);
  const [showProAccSearch, setShowProAccSearch] = useState(false);
  const [hideProAcc, setHideProAcc] = useState(true);
  const [proAccName, setProAccName] = useState("");

  const [relatedProBranch, setRelatedProBranch] = useState([]);
  const [showBranch, setShowBranch] = useState(false);

  const [proUnitLists, setProUnitLists] = useState([]);
  const [medUnitLists, setMedUnitLists] = useState([]);
  const [proAssLists, setProAssLists] = useState([]);
  const [showMedicine, setShowMedicine] = useState(true);
  const [showProUnit, setShowProUnit] = useState(false);
  const [showProAss, setShowProAss] = useState(false);
  const [type, setType] = useState("");

  const [branchesLists, setBranchesLists] = useState([]);

  const [mQty, setMQty] = useState("");

  const [mTotal, setMTotal] = useState("");
  const [mSell, setMSell] = useState(0);
  const [mPurchase, setMPurchase] = useState(0);

  const [pmQty, setPMQty] = useState("");

  const [pmTotal, setPMTotal] = useState("");
  const [pmSell, setPMSell] = useState(0);
  const [pmPurchase, setPMPurchase] = useState(0);

  const [paQty, setPAQty] = useState("");

  const [paTotal, setPATotal] = useState("");
  const [paSell, setPASell] = useState(0);
  const [paPurchase, setPAPurchase] = useState(0);
  const [medTotal, setMedTotal] = useState("");
  const [proTotal, setProTotal] = useState("");
  const [proAssTotal, setProAssTotal] = useState("");
  const [typeFilterList, setTypeFilterList] = useState([]);
  const [showType, setShowType] = useState(false);

  const [proId, setProId] = useState("");
  // const [proName, setProName] = useState('')

  const ButtonStyle = { margin: "10px 10px" };
  const ErrorColor = { border: "red" };

  const handleUpdateUnitCalculation = (event, proUnit, type) => {
    // console.log(qty, 'qty')
    // console.log(event, 'event')

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = uQty * proUnit.toUnit;
      console.log(uQty);
      console.log(total);
      setPMTotal(total);
      setPMQty(event);
      const newData = proUnitLists.map((data) => {
        if (data._id === proUnit._id) {
          return { ...data, [type]: parseInt(event), totalUnit: total };
        }
        return data;
      });
      console.log(newData);
      setProUnitLists(newData);
    } else if (type === "toUnit") {
      let total = parseInt(event) * proUnit.currentQuantity;
      setPMTotal(total);
      console.log(total);
      const newData = proUnitLists.map((data) => {
        if (data._id === proUnit._id) {
          return { ...data, [type]: parseInt(event), totalUnit: total };
        }
        return data;
      });
      console.log(newData);
      setProUnitLists(newData);
    }
  };

  const handleMUpdateUnitCalculation = (event, medUnit, type) => {
    // console.log(qty, 'qty')
    // console.log(event, 'event')

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = uQty * medUnit.toUnit;
      console.log(uQty);
      console.log(total);
      setMTotal(total);
      setMQty(event);
      const newData = medUnitLists.map((data) => {
        if (data._id === medUnit._id) {
          return { ...data, [type]: parseInt(event), totalUnit: total };
        }
        return data;
      });
      console.log(newData);
      setMedUnitLists(newData);
    } else if (type === "toUnit") {
      let total = parseInt(event) * medUnit.currentQuantity;
      setMTotal(total);
      console.log(total);
      const newData = medUnitLists.map((data) => {
        if (data._id === medUnit._id) {
          return { ...data, [type]: parseInt(event), totalUnit: total };
        }
        return data;
      });
      console.log(newData);
      setMedUnitLists(newData);
    }
  };

  const handlePAUpdateUnitCalculation = (event, paUnit, type) => {
    // console.log(qty, 'qty')
    // console.log(event, 'event')

    if (type === "currentQuantity") {
      let uQty = parseInt(event);
      let total = uQty * paUnit.toUnit;
      console.log(uQty);
      console.log(total);
      setPATotal(total);
      setPAQty(event);
      const newData = proAssLists.map((data) => {
        if (data._id === paUnit._id) {
          return { ...data, [type]: parseInt(event), totalUnit: total };
        }
        return data;
      });
      console.log(newData);
      setProAssLists(newData);
    } else if (type === "toUnit") {
      let total = parseInt(event) * paUnit.currentQuantity;
      setPATotal(total);
      console.log(total);
      const newData = proAssLists.map((data) => {
        if (data._id === paUnit._id) {
          return { ...data, [type]: parseInt(event), totalUnit: total };
        }
        return data;
      });
      console.log(newData);
      setProAssLists(newData);
    }
  };

  const handlePMUpdate = (proUnit) => {
    //console.log(proId,'pro')
    const data = {
      id: proUnit._id,
      currentQuantity: proUnit.currentQuantity,
      fromUnit: proUnit.fromUnit,
      toUnit: proUnit.toUnit,
      totalUnit: proUnit.totalUnit,
    };

    if (pmPurchase > 0) {
      data.purchasePrice = parseInt(pmPurchase);
    }
    if (pmSell > 0) {
      data.sellingPrice = parseInt(pmSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("procedure-item", data, config)
      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleMUpdate = (medUnit) => {
    //console.log(proId,'pro')
    const data = {
      id: medUnit._id,
      currentQuantity: medUnit.currentQuantity,
      fromUnit: medUnit.fromUnit,
      toUnit: medUnit.toUnit,
      totalUnit: medUnit.totalUnit,
    };

    if (mPurchase > 0) {
      data.purchasePrice = parseInt(mPurchase);
    }
    if (mSell > 0) {
      data.sellingPrice = parseInt(mSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("medicine-item", data, config)
      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handlePAUpdate = (paUnit) => {
    //console.log(proId,'pro')
    const data = {
      id: paUnit._id,
      currentQuantity: paUnit.currentQuantity,
      fromUnit: paUnit.fromUnit,
      toUnit: paUnit.toUnit,
      totalUnit: paUnit.totalUnit,
    };

    if (paPurchase > 0) {
      data.purchasePrice = parseInt(paPurchase);
    }
    if (paSell > 0) {
      data.sellingPrice = parseInt(paSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("accessory-item", data, config)
      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleMedUnitChange = () => {
    setShowMedicine(true);
    setShowProUnit(false);
    setShowProAss(false);
    setHideMed(true);
    setShowBranch(false);
    setShowType(false);
    if (type) {
      window.location.reload();
    }
  };

  const handleProUnitChange = () => {
    setShowMedicine(false);
    setShowProUnit(true);
    setShowProAss(false);
    setHidePro(true);
    setShowBranch(false);
  };

  const handleProAssUnitChange = () => {
    setShowProAss(true);
    setShowMedicine(false);
    setShowProUnit(false);
    setShowBranch(false);
    setHideProAcc(true);
  };

  const _export1 = React.useRef(null);
  const _export2 = React.useRef(null);
  const _export3 = React.useRef(null);

  const excelExport1 = () => {
    if (_export1.current !== null) {
      console.log(_export1.current.props.data, "excel");

      _export1.current.props.data.map(function (element, index) {
        element.code = element.code;
      });

      _export1.current.save();
    }
  };

  const excelExport2 = () => {
    if (_export2.current !== null) {
      console.log(_export2.current.props.data, "excel");
      if (_export2.current.props.data === { medUnitLists }) {
        _export2.current.props.data.map(function (element, index) {
          element.code = element.code;
        });
      }
      _export2.current.save();
    }
  };

  const excelExport3 = () => {
    if (_export3.current !== null) {
      console.log(_export3.current.props.data, "excel");
      _export3.current.props.data.map(function (element, index) {
        element.code = element.code;
      });
      _export3.current.save();
    }
  };

  useEffect(() => {
    const getProUnitLists = async () => {
      try {
        const res = await api.get("procedure-items?limit=30");
        setProUnitLists(res.data.list);

        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0
        );
        setProTotal(totalPrice);

        setProId(res.data.list._id);
        // if (setProUnitLists.reOrderQuantity === 0) {
        // }
      } catch (err) {
        alert(err.message);
      }
    };

    const getMedUnitLists = async () => {
      try {
        const res = await api.get("medicine-items?limit=30");

        setMedUnitLists(res.data.list);
        // console.log(res.data.list,'mmmmm')
        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0
        );
        setMedTotal(totalPrice);
      } catch (err) {
        alert(err.message);
      }
    };

    // const getBranches = async () => {
    //   try {
    //     const res = await axios.get(apiURL + 'branches')
    //     setBranchesLists(res.data.list)
    //   } catch (err) {
    //     alert(err.message)
    //   }
    // }

    const getProAssLists = async () => {
      try {
        const res = await api.get("accessory-items?limit=30");
        setProAssLists(res.data.list);
        console.log(res.data.list, "p acc");
        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0
        );
        setProAssTotal(totalPrice);

        console.log(setProAssLists._id);
      } catch (err) {
        alert(err.message);
      }
    };

    getProAssLists();
    getMedUnitLists();
    getProUnitLists();
  }, []);

  const handleType = (type) => {
    setType(type);
    if (type === "All") {
      setShowType(false);
      setShowMedSearch(false);
      setHideMed(true);
    } else {
      setTypeFilterList(medUnitLists.filter((el) => el.itemType === type));
      setShowType(true);
      setShowMedSearch(false);
      setHideMed(false);
    }
    // if (handleProUnitChange() || handleProAssUnitChange()) {
    //   setHideMed(window.location.reload())
    // }
  };
  const search = (event) => {
    if (event) {
      setSearchProResults(
        proUnitLists.filter(
          (el) =>
            (el.procedureItemName ? el.procedureItemName : "")
              .toLowerCase()
              .includes(event.toLowerCase()) ||
            (el.code ? el.code : "").toLowerCase().includes(event.toLowerCase())
        )
      );

      setShowProSearch(true);
      setShowMedSearch(false);
      setShowProAccSearch(false);

      setHidePro(false);
    } else {
      setShowProSearch(false);
      setHidePro(true);
    }
  };
  const medSearch = (medName) => {
    // console.log(medName, 'name')
    // console.log(medUnitLists, 'med list')

    if (medName) {
      setSearchMedResults(
        medUnitLists.filter(
          (el) =>
            el?.medicineItemName
              .toLowerCase()
              .includes(medName.toLowerCase()) ||
            (el?.code).toLowerCase().includes(medName.toLowerCase())
        )
      );

      setShowMedSearch(true);
      setShowProSearch(false);
      setShowProAccSearch(false);

      setHideMed(false);
    } else {
      setShowMedSearch(false);
      setShowProSearch(false);
      setShowProAccSearch(false);

      setHideMed(true);
    }
  };

  const proAccSearch = (event) => {
    // console.log(event, 'name')
    if (event) {
      setSearchProAccResults(
        proAssLists.filter(
          (el) =>
            (el?.accessoryItemName)
              .toLowerCase()
              .includes(event.toLowerCase()) ||
            el.code.toLowerCase().includes(event.toLowerCase())
        )
      );

      setShowProAccSearch(true);
      setHideProAcc(false);
    } else {
      setShowProAccSearch(false);
      setHideProAcc(true);
    }
  };

  const handleMedStockQtyCalculate = () => {
    const data = {
      medicineItems: medUnitLists.map((i) => i._id),
      procedureItems: [],
      accessoryItems: [],
    };
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("items/confirm", data, config)
      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Calculated",
          icon: "success",

          cancelButtonText: "Close",
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  const handleProStockQtyCalculate = () => {
    const data = {
      medicineItems: [],
      procedureItems: proUnitLists.map((i) => i._id),
      accessoryItems: [],
    };
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("items/confirm", data, config)
      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Calculated",
          icon: "success",

          cancelButtonText: "Close",
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  const handleProAssStockQtyCalculate = () => {
    const data = {
      medicineItems: [],
      procedureItems: [],
      accessoryItems: proAssLists.map((i) => i._id),
    };
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("items/confirm", data, config)
      .then(function (response) {
        console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Calculated",
          icon: "success",

          cancelButtonText: "Close",
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };
  return (
    <>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active fs-5">
                  Stock Count & Price
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Main content --> */}

      <section className="content">
        <div className="container-fluid">
          <div className="row d-flex justify-content-between ">
            <div className="col-md-6">{/* <h4>Medicine Item List</h4> */}</div>
            <div className="offset-1 col-md-4 ml-5">
              <div
                className="input-group row ml-5"
                style={{ marginBottom: "20px" }}
              >
                {/* <div className="col-md-6 mt-1">
                      <button
                        type="button"
                        className="btn  btn-primary ml-4"
                        style={{ borderRadius: "7px" }}
                        onClick={showDialog}>
                        Add Item
                      </button>
                    </div> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-4">
                          <Button
                            style={ButtonStyle}
                            onClick={(e) => handleMedUnitChange(e.target.value)}
                          >
                            Medicine Items
                          </Button>
                        </div>
                        <div className="col-md-4">
                          <Button
                            style={ButtonStyle}
                            onClick={(e) => handleProUnitChange(e.target.value)}
                          >
                            Procedure Items
                          </Button>
                        </div>
                        <div className="col-md-4">
                          <Button
                            style={ButtonStyle}
                            onClick={(e) =>
                              handleProAssUnitChange(e.target.value)
                            }
                          >
                            Procedure Accessories
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  {/* Export data in Excel */}
                  {/* For Procedure Medicine Items */}
                  <ExcelExport data={proUnitLists} ref={_export1}>
                    <ExcelExportColumn
                      field=""
                      title="No"
                      locked={true}
                      width={30}
                    />
                    <ExcelExportColumn
                      field="code"
                      title="Code"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={200}
                    />
                    <ExcelExportColumn
                      field="procedureItemName"
                      title="Procedure Item Name"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={250}
                    />
                    <ExcelExportColumn
                      field="currentQuantity"
                      title="Qty"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={250}
                    />
                    <ExcelExportColumn
                      field="fromUnit"
                      title="From Unit"
                      width={150}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="toUnit"
                      title="To Unit"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="totalUnit"
                      title="Total Unit"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="sellingPrice"
                      title="Selling Price"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />
                    <ExcelExportColumn
                      field="purchasePrice"
                      title="Purchase Price"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="actualStock"
                      title="Actual Stock"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="different"
                      title="Different"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />
                  </ExcelExport>
                  {/* End        */}

                  {/* For Medicine Items */}
                  <ExcelExport data={medUnitLists} ref={_export2}>
                    <ExcelExportColumn
                      field=""
                      title="No"
                      locked={true}
                      width={30}
                    />
                    <ExcelExportColumn
                      field="code"
                      title="Code"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={200}
                    />
                    <ExcelExportColumn
                      field="medicineItemName"
                      title="Medicine Item Name"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={250}
                    />
                    <ExcelExportColumn
                      field="currentQuantity"
                      title="Qty"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={250}
                    />
                    <ExcelExportColumn
                      field="fromUnit"
                      title="From Unit"
                      width={150}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="toUnit"
                      title="To Unit"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="totalUnit"
                      title="Total Unit"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="sellingPrice"
                      title="Selling Price"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />
                    <ExcelExportColumn
                      field="purchasePrice"
                      title="Purchase Price"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="actualStock"
                      title="Actual Stock"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="different"
                      title="Different"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />
                  </ExcelExport>
                  {/* End     */}

                  {/* For Procedure Accessory FilterItems */}
                  <ExcelExport data={proAssLists} ref={_export3}>
                    <ExcelExportColumn
                      field=""
                      title="No"
                      locked={true}
                      width={30}
                    />
                    <ExcelExportColumn
                      field="code"
                      title="Code"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={200}
                    />
                    <ExcelExportColumn
                      field="accessoryItemName"
                      title="Procedure Accessory Item Name"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={250}
                    />
                    <ExcelExportColumn
                      field="currentQuantity"
                      title="Qty"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={250}
                    />
                    <ExcelExportColumn
                      field="fromUnit"
                      title="From Unit"
                      width={150}
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                    />
                    <ExcelExportColumn
                      field="toUnit"
                      title="To Unit"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="totalUnit"
                      title="Total Unit"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="sellingPrice"
                      title="Selling Price"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />
                    <ExcelExportColumn
                      field="purchasePrice"
                      title="Purchase Price"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="actualStock"
                      title="Actual Stock"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />

                    <ExcelExportColumn
                      field="different"
                      title="Different"
                      headerCellOptions={{
                        textAlign: "center",
                      }}
                      width={150}
                    />
                  </ExcelExport>

                  {/* End */}

                  {/* Export Data in Excel end */}
                  <div className="row">
                    <div className="col-md-12">
                      <div className="" style={scroll}>
                        <table className="table table-hover table-responsive-md">
                          {showProUnit && (
                            <div>
                              <div className="row justify-content-between mb-3">
                                <div className="col-md-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-dark"
                                    onClick={excelExport1}
                                  >
                                    <FaFileExport />
                                    &nbsp; Export
                                  </button>
                                </div>
                                <div className="col-md-3 mt-1">
                                  <b className="btn btn-sm btn-dark">
                                    Total Inventory Value :{" "}
                                    {proTotal ? proTotal.toFixed(2) : "0"} MMK
                                  </b>
                                </div>

                                <div className="col-md-3 mr-2">
                                  <div className="row">
                                    <div className="offset-3 col-md-8">
                                      <input
                                        type="search"
                                        className="form-control rounded "
                                        style={{ borderRadius: "17px" }}
                                        onChange={(e) => search(e.target.value)}
                                        id="search_code"
                                        placeholder="Search Items"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-2 mt-2">
                                  <button
                                    onClick={handleProStockQtyCalculate}
                                    className="btn btn-success"
                                  >
                                    <FaCalculator />
                                  </button>{" "}
                                  &nbsp;
                                  {/* <button className='btn btn-md btn-success'><FaClipboardList /></button> */}
                                </div>
                              </div>
                              <div>
                                <thead className="sticky-top">
                                  <tr>
                                    <th
                                      style={{ fontWeight: "400px" }}
                                      className="text-center"
                                    >
                                      #
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Code
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Name
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>Qty</th>
                                    <th style={{ fontWeight: "400px" }}>
                                      From Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      To Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Total Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Selling( MMK )
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Purchase( MMK )
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Unit
                                    </th>
                                    <th>Opening Qty</th>
                                    <th>Purchase Qty</th>
                                    <th>Used Qty</th>
                                    <th>Closing Qty</th>
                                    <th
                                      className="text-center"
                                      style={{ fontWeight: "400px" }}
                                    >
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {hidePro &&
                                    proUnitLists.map((proUnit, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{proUnit.code}</td>
                                        <td>{proUnit.procedureItemName}</td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              proUnit.currentQuantity
                                            }
                                            onChange={(e) =>
                                              handleUpdateUnitCalculation(
                                                e.target.value,
                                                proUnit,
                                                "currentQuantity"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proUnit.fromUnit}
                                            //  onChange={(e)=>setFrom(e.target.value)}
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proUnit.toUnit}
                                            onChange={(e) =>
                                              handleUpdateUnitCalculation(
                                                e.target.value,
                                                proUnit,
                                                "toUnit"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={
                                              (proUnit.toUnit *
                                                proUnit.currentQuantity) /
                                              proUnit.fromUnit
                                            }
                                            className="form-control"
                                            disabled
                                            //onChange={(e)=>setPMTotal(e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proUnit.sellingPrice}
                                            onChange={(e) =>
                                              setPMSell(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proUnit.purchasePrice}
                                            onChange={(e) =>
                                              setPMPurchase(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>PCS</td>
                                        <td>
                                          {proUnit.openingQty
                                            ? proUnit.openingQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proUnit.purchaseQty
                                            ? proUnit.purchaseQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proUnit.useQty ? proUnit.useQty : 0}
                                        </td>
                                        <td>
                                          {proUnit.closingQty
                                            ? proUnit.closingQty
                                            : 0}
                                        </td>
                                        <td className="text-center">
                                          <button
                                            onClick={(e) =>
                                              handlePMUpdate(proUnit)
                                            }
                                            class="btn btn-sm btn-primary mt-3"
                                            // data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}

                                  {showProSearch &&
                                    searchProResults.map((proUnit, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{proUnit.code}</td>
                                        <td>{proUnit.procedureItemName}</td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              proUnit.currentQuantity
                                            }
                                            onChange={(e) =>
                                              handlePAUpdateUnitCalculation(
                                                e.target.value,
                                                proUnit,
                                                "currentQuantity"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proUnit.fromUnit}
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proUnit.toUnit}
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                proUnit,
                                                "toUnit"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={
                                              (proUnit.toUnit *
                                                proUnit.currentQuantity) /
                                              proUnit.fromUnit
                                            }
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proUnit.sellingPrice}
                                            onChange={(e) =>
                                              setPASell(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proUnit.purchasePrice}
                                            onChange={(e) =>
                                              setPAPurchase(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>PCS</td>
                                        <td>
                                          {proUnit.openingQty
                                            ? proUnit.openingQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proUnit.purchaseQty
                                            ? proUnit.purchaseQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proUnit.useQty ? proUnit.useQty : 0}
                                        </td>
                                        <td>
                                          {proUnit.closingQty
                                            ? proUnit.closingQty
                                            : 0}
                                        </td>
                                        <td className="text-center">
                                          {/* <Link
                                            to={
                                              '/stockProAss/' + proUnit._id
                                            }
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                          <button
                                            onClick={(e) =>
                                              handlePAUpdate(proUnit)
                                            }
                                            class="btn btn-sm btn-primary mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </div>
                            </div>
                          )}

                          {showMedicine && (
                            <div>
                              <div className="row justify-content-between mb-3">
                                <div className="col-md-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-dark"
                                    onClick={excelExport2}
                                  >
                                    <FaFileExport />
                                    &nbsp; Export
                                  </button>
                                </div>

                                <div className="col-md-3 mt-1">
                                  <b className="btn btn-sm btn-dark">
                                    Total Inventory Value :{" "}
                                    {medTotal ? medTotal.toFixed(2) : "0"} MMK
                                  </b>
                                </div>

                                <div className="col-md-6 mr-2">
                                  <div className="row">
                                    <div
                                      className="col-3"
                                      style={{ marginTop: "0.5em" }}
                                    >
                                      <select
                                        className="form-control"
                                        onChange={(e) =>
                                          handleType(e.target.value)
                                        }
                                      >
                                        <option hidden>Select Type</option>
                                        <option value="All">All</option>

                                        <option value="Oral">Oral</option>
                                        <option value="Topical">Topical</option>
                                        <option value="Comestic">
                                          Comestic
                                        </option>
                                        <option value="Consignment">
                                          Consignment
                                        </option>
                                        <option value="Accessories">
                                          Accessories
                                        </option>
                                      </select>
                                    </div>

                                    <div className=" col-md-4">
                                      <input
                                        type="search"
                                        className="form-control rounded "
                                        style={{ borderRadius: "17px" }}
                                        onChange={(e) =>
                                          medSearch(e.target.value)
                                        }
                                        id="search_code"
                                        placeholder="Search Items"
                                      />
                                    </div>
                                    <div className="col-2 mt-2">
                                      <button
                                        onClick={handleMedStockQtyCalculate}
                                        className="btn btn-success"
                                      >
                                        <FaCalculator />
                                      </button>{" "}
                                      &nbsp;
                                      {/* <button className='btn btn-md btn-success'><FaClipboardList /></button> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="">
                                <thead
                                  className="sticky-top "
                                  style={{ scroll }}
                                >
                                  <tr>
                                    <th
                                      style={{ fontWeight: "400px" }}
                                      className="text-center"
                                    >
                                      #
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Code
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Name
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>Qty</th>
                                    <th style={{ fontWeight: "400px" }}>
                                      From Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      To Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Total Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Selling( MMK )
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Purchase( MMK )
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Unit
                                    </th>
                                    <th>Type</th>
                                    <th>Opening Qty</th>
                                    <th>Purchase Qty</th>
                                    <th>Used Qty</th>
                                    <th>Closing Qty</th>
                                    <th
                                      className="text-center"
                                      style={{ fontWeight: "400px" }}
                                    >
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody id="table_body">
                                  {hideMed &&
                                    medUnitLists.map((medUnit, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{medUnit.code}</td>
                                        <td>{medUnit.medicineItemName}</td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              medUnit.currentQuantity
                                            }
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                medUnit,
                                                "currentQuantity"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.fromUnit}
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.toUnit}
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                medUnit,
                                                "toUnit"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={
                                              (medUnit.toUnit *
                                                medUnit.currentQuantity) /
                                              medUnit.fromUnit
                                            }
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.sellingPrice}
                                            onChange={(e) =>
                                              setMSell(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.purchasePrice}
                                            onChange={(e) =>
                                              setMPurchase(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>PCS</td>
                                        <td>
                                          {medUnit.itemType
                                            ? medUnit.itemType
                                            : ""}
                                        </td>
                                        <td>
                                          {medUnit.openingQty
                                            ? medUnit.openingQty
                                            : 0}
                                        </td>
                                        <td>
                                          {medUnit.purchaseQty
                                            ? medUnit.purchaseQty
                                            : 0}
                                        </td>
                                        <td>
                                          {medUnit.useQty ? medUnit.useQty : 0}
                                        </td>
                                        <td>
                                          {medUnit.closingQty
                                            ? medUnit.closingQty
                                            : 0}
                                        </td>
                                        <td className="">
                                          <button
                                            onClick={(e) =>
                                              handleMUpdate(medUnit)
                                            }
                                            class="btn btn-sm btn-primary mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  {showMedSearch &&
                                    searchMedResults.map((medUnit, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{medUnit.code}</td>
                                        <td>{medUnit.medicineItemName}</td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              medUnit.currentQuantity
                                            }
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                medUnit,
                                                "currentQuantity"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.fromUnit}
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.toUnit}
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                medUnit,
                                                "toUnit"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={
                                              (medUnit.toUnit *
                                                medUnit.currentQuantity) /
                                              medUnit.fromUnit
                                            }
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.sellingPrice}
                                            onChange={(e) =>
                                              setMSell(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.purchasePrice}
                                            onChange={(e) =>
                                              setMPurchase(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>PCS</td>
                                        <td>
                                          {medUnit.itemType
                                            ? medUnit.itemType
                                            : ""}
                                        </td>
                                        <td>
                                          {medUnit.openingQty
                                            ? medUnit.openingQty
                                            : 0}
                                        </td>
                                        <td>
                                          {medUnit.purchaseQty
                                            ? medUnit.purchaseQty
                                            : 0}
                                        </td>
                                        <td>
                                          {medUnit.useQty ? medUnit.useQty : 0}
                                        </td>
                                        <td>
                                          {medUnit.closingQty
                                            ? medUnit.closingQty
                                            : 0}
                                        </td>
                                        <td className="text-center">
                                          {/* <Link
                                            to={'/stockMed/' + medUnit._id}
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                          <button
                                            onClick={(e) =>
                                              handleMUpdate(medUnit)
                                            }
                                            class="btn btn-sm btn-primary mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}

                                  {showType &&
                                    typeFilterList.map((medUnit, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{medUnit.code}</td>
                                        <td>{medUnit.medicineItemName}</td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              medUnit.currentQuantity
                                            }
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                medUnit,
                                                "currentQuantity"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.fromUnit}
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.toUnit}
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                medUnit,
                                                "toUnit"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={
                                              (medUnit.toUnit *
                                                medUnit.currentQuantity) /
                                              medUnit.fromUnit
                                            }
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.sellingPrice}
                                            onChange={(e) =>
                                              setMSell(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={medUnit.purchasePrice}
                                            onChange={(e) =>
                                              setMPurchase(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>PCS</td>
                                        <td>
                                          {medUnit.itemType
                                            ? medUnit.itemType
                                            : ""}
                                        </td>
                                        <td>
                                          {medUnit.openingQty
                                            ? medUnit.openingQty
                                            : 0}
                                        </td>
                                        <td>
                                          {medUnit.purchaseQty
                                            ? medUnit.purchaseQty
                                            : 0}
                                        </td>
                                        <td>
                                          {medUnit.useQty ? medUnit.useQty : 0}
                                        </td>
                                        <td>
                                          {medUnit.closingQty
                                            ? medUnit.closingQty
                                            : 0}
                                        </td>

                                        <td className="text-center">
                                          {/* <Link
                                            to={'/stockMed/' + medUnit._id}
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                          <button
                                            onClick={(e) =>
                                              handleMUpdate(medUnit)
                                            }
                                            class="btn btn-sm btn-primary mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </div>
                            </div>
                          )}

                          {showProAss && (
                            <div>
                              <div className="row justify-content-between mb-3">
                                <div className="col-md-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-dark"
                                    onClick={excelExport3}
                                  >
                                    <FaFileExport />
                                    &nbsp; Export
                                  </button>
                                </div>
                                <div className="col-md-3 mt-1">
                                  <b className="btn btn-sm btn-dark">
                                    Total Inventory Value :{" "}
                                    {proAssTotal ? proAssTotal.toFixed(2) : "0"}{" "}
                                    MMK
                                  </b>
                                </div>

                                <div className="col-md-5 mr-2">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <input
                                        type="search"
                                        className="form-control rounded "
                                        style={{ borderRadius: "17px" }}
                                        onChange={(e) =>
                                          proAccSearch(e.target.value)
                                        }
                                        id="search_code"
                                        placeholder="Search Items"
                                      />
                                    </div>
                                    <div className="col-4 mt-2">
                                      <button
                                        onClick={handleProAssStockQtyCalculate}
                                        className="btn btn-success"
                                      >
                                        <FaCalculator />
                                      </button>{" "}
                                      &nbsp;
                                      {/* <button className='btn btn-md btn-success'><FaClipboardList /></button> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div style={scroll}>
                                <thead
                                  style={{ width: "100%" }}
                                  className="sticky-top"
                                >
                                  <tr>
                                    <th
                                      style={{ fontWeight: "400px" }}
                                      className="text-center"
                                    >
                                      #
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Code
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Name
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>Qty</th>
                                    <th style={{ fontWeight: "400px" }}>
                                      From Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      To Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Total Unit
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Selling( MMK )
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Purchase( MMK )
                                    </th>
                                    <th style={{ fontWeight: "400px" }}>
                                      Unit
                                    </th>
                                    <th>Opening Qty</th>
                                    <th>Purchase Qty</th>
                                    <th>Used Qty</th>
                                    <th>Closing Qty</th>
                                    <th
                                      className="text-center"
                                      style={{ fontWeight: "400px" }}
                                    >
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {hideProAcc &&
                                    proAssLists.map((proAssUnit, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{proAssUnit.code}</td>
                                        <td>{proAssUnit.accessoryItemName}</td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              proAssUnit.currentQuantity
                                            }
                                            onChange={(e) =>
                                              handlePAUpdateUnitCalculation(
                                                e.target.value,
                                                proAssUnit,
                                                "currentQuantity"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proAssUnit.fromUnit}
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proAssUnit.toUnit}
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                proAssUnit,
                                                "toUnit"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={
                                              (proAssUnit.toUnit *
                                                proAssUnit.currentQuantity) /
                                              proAssUnit.fromUnit
                                            }
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              proAssUnit.sellingPrice
                                            }
                                            onChange={(e) =>
                                              setPASell(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              proAssUnit.purchasePrice
                                            }
                                            onChange={(e) =>
                                              setPAPurchase(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>PCS</td>
                                        <td>
                                          {proAssUnit.openingQty
                                            ? proAssUnit.openingQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proAssUnit.purchaseQty
                                            ? proAssUnit.purchaseQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proAssUnit.useQty
                                            ? proAssUnit.useQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proAssUnit.closingQty
                                            ? proAssUnit.closingQty
                                            : 0}
                                        </td>
                                        <td className="text-center">
                                          {/* <Link
                                            to={
                                              '/stockProAss/' + proAssUnit._id
                                            }
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                          <button
                                            onClick={(e) =>
                                              handlePAUpdate(proAssUnit)
                                            }
                                            class="btn btn-sm btn-primary mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}

                                  {showProAccSearch &&
                                    searchProAccResults.map((proAssUnit, i) => (
                                      <tr>
                                        <td>{++i}</td>
                                        <td>{proAssUnit.code}</td>
                                        <td>{proAssUnit.accessoryItemName}</td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              proAssUnit.currentQuantity
                                            }
                                            onChange={(e) =>
                                              handlePAUpdateUnitCalculation(
                                                e.target.value,
                                                proAssUnit,
                                                "currentQuantity"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proAssUnit.fromUnit}
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={proAssUnit.toUnit}
                                            onChange={(e) =>
                                              handleMUpdateUnitCalculation(
                                                e.target.value,
                                                proAssUnit,
                                                "toUnit"
                                              )
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            value={
                                              (proAssUnit.toUnit *
                                                proAssUnit.currentQuantity) /
                                              proAssUnit.fromUnit
                                            }
                                            disabled
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              proAssUnit.sellingPrice
                                            }
                                            onChange={(e) =>
                                              setPASell(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            defaultValue={
                                              proAssUnit.purchasePrice
                                            }
                                            onChange={(e) =>
                                              setPAPurchase(e.target.value)
                                            }
                                            className="form-control"
                                          />
                                        </td>
                                        <td>PCS</td>
                                        <td>
                                          {proAssUnit.openingQty
                                            ? proAssUnit.openingQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proAssUnit.purchaseQty
                                            ? proAssUnit.purchaseQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proAssUnit.useQty
                                            ? proAssUnit.useQty
                                            : 0}
                                        </td>
                                        <td>
                                          {proAssUnit.closingQty
                                            ? proAssUnit.closingQty
                                            : 0}
                                        </td>
                                        <td>
                                          {/* <Link
                                            to={
                                              '/stockProAss/' + proAssUnit._id
                                            }
                                            class='btn btn-sm btn-primary'
                                            data-toggle='modal'
                                            data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </Link> */}
                                          <button
                                            onClick={(e) =>
                                              handlePAUpdate(proAssUnit)
                                            }
                                            class="btn btn-sm btn-primary mt-3"
                                            //data-toggle='modal'
                                            // data-target='#edit_stock{{$list->id}}'
                                          >
                                            <FaAngleDoubleRight />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </div>
                            </div>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <ProMedicine
                open={open}
                close={() => setOpen(false)}
                setProMedicineLists={setProMedicineLists}
                proMedicineLists={proMedicineLists}
              /> */}
        </div>
      </section>
    </>
  );
}
export default Stock;
